import { Grid, Card, CardContent, Typography, Icon } from '@mui/material'
import { Lock } from 'react-feather'
import { useLocation, useParams } from 'react-router-dom'
import { AllowedAccess } from 'react-permission-role'

import { useFetchInitCreditsCollateral } from './hooks'
import { CollateralTable } from './CollateralTable/CollateralTable'
import { ModalModule } from './Modal'
import { CollateralImages } from './CollateralImages/CollateralImages'

export const CreditsCollateral = () => {
  const location = useLocation()
  const paramsURL = useParams()
  const useFetchInit = useFetchInitCreditsCollateral({ location, paramsURL })

  const { globalStates } = useFetchInit
  const { showForm, showSection } = globalStates

  // ✅ Fallback: si por alguna razón showSection viene vacío, asumimos HOME
  const currentSection = showSection || 'HOME'
  const isHome = currentSection === 'HOME'
  const isImage = currentSection === 'IMAGE'

  return (
    <AllowedAccess permissions={['239_CREDITOS_GARANTIAS']} renderAuthFailed={<p>Error</p>}>
      <div className='content'>
        {!showForm && (
          <div className='panel-body' id='listadoregistros'>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card>
                  <CardContent>

                    {isHome && (
                      <>
                        <Grid item xs={12} sx={{ mt: 1, mb: 3 }}>
                          <ModalModule useFetchInit={useFetchInit} />
                          <Typography variant='h4' sx={{ display: 'flex', alignItems: 'center' }}>
                            Garantías
                            <Icon component={Lock} sx={{ ml: 1, fontSize: '1.5rem' }} />
                          </Typography>
                        </Grid>

                        <div className="pt-4"></div>
                        <CollateralTable useFetchInit={useFetchInit} />
                      </>
                    )}

                    {isImage && (
                      <CollateralImages useFetchInit={useFetchInit} />
                    )}

                    {/* ✅ Safety net: si cae en un estado desconocido, muestra HOME */}
                    {!isHome && !isImage && (
                      <>
                        <Grid item xs={12} sx={{ mt: 1, mb: 3 }}>
                          <ModalModule useFetchInit={useFetchInit} />
                          <Typography variant='h4' sx={{ display: 'flex', alignItems: 'center' }}>
                            Garantías
                            <Icon component={Lock} sx={{ ml: 1, fontSize: '1.5rem' }} />
                          </Typography>
                        </Grid>

                        <div className="pt-4"></div>
                        <CollateralTable useFetchInit={useFetchInit} />
                      </>
                    )}

                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </div>
        )}
      </div>
    </AllowedAccess>
  )
}
